/**
 * ConsentClient — Posts consent decisions to the collect-consent Edge Function.
 */

import type { ConsentDecisions } from "../core/StorageAdapter";
import type { GeoResult } from "../core/GeoDetector";

export class ConsentClient {
  private apiUrl: string;
  private domainId: string;

  constructor(apiUrl: string, domainId: string) {
    this.apiUrl = apiUrl;
    this.domainId = domainId;
  }

  async record(
    sessionId: string,
    decisions: ConsentDecisions,
    geo: GeoResult,
    bannerVersion: number,
    tcString?: string
  ): Promise<void> {
    try {
      await fetch(`${this.apiUrl}/functions/v1/collect-consent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          domainId: this.domainId,
          sessionId,
          decisions,
          regulation: geo.regulation,
          country: geo.country,
          pageUrl: window.location.href,
          bannerVersion,
          ...(tcString ? { tcString } : {}),
        }),
        // Use a normal POST here. keepalive + abort timing can produce
        // hard-to-diagnose partial/empty bodies on fire-and-forget requests.
      });
    } catch {
      // Fire-and-forget — never block the user experience
    }
  }
}
